import React from 'react';
import { GridColDef } from '@mui/x-data-grid';
import { useGridApiContext } from '@mui/x-data-grid-pro';
import { DateRangePicker } from 'app/ComponentLibrary/DateRangeNew';
import moment from 'moment';
import { selectUser } from 'oidc/user.selectors';
import { useSelector } from 'react-redux';
import { userAllowedToEdit } from '../../helper';
import { handleGridCellChangeAndStopEdit } from './changeDetectionHelper';

const GridCellDate = React.memo(function GridCellDate(props: any) {
  const { id, value, field, error, row } = props;
  const apiRef = useGridApiContext();
  const [editValue, setEditValue] = React.useState<any>(value);
  const user = useSelector(selectUser);

  const allowEdit = React.useMemo(() => {
    return userAllowedToEdit(user?.userInfo) || row?.allowEdit;
  }, [row?.allowEdit, user?.userInfo]);

  const handleChange = async (selectedValue: any) => {
    const newValue = selectedValue?.label || null;
    
    setEditValue(newValue);

    // Use the helper function for change detection and grid updates
    await handleGridCellChangeAndStopEdit({
      id,
      field,
      newValue,
      oldValue: value,
      apiRef,
    });
  };

  return (
    <DateRangePicker
      placeholder="MM/DD/YYYY"
      onChange={handleChange}
      value={editValue}
      variant="standard"
      size="inline"
      actionBar={false}
      single
      helperTextDisabled={true}
      clickAway
      useMaxWidth={false}
      clear
      trailingIconShow={true}
      disableUnderline={true}
      showIcon={true}
      isDateIconReq={true}
      helperBackgroundColor={'transparent'}
      initialDateRange={
        moment(editValue)?.isValid() && {
          startDate: new Date(editValue),
          endDate: new Date(editValue),
          label: moment(editValue).format('MM/DD/YYYY'),
          useLabelAsValue: false,
        }
      }
      definedRanges={[]}
      minDate={new Date('01-01-1940')}
      isDisabled={!allowEdit}
    />
  );
});

export const renderGridCellDate: GridColDef['renderCell'] = params => {
  return <GridCellDate {...params} />;
};
